module.exports = __webpack_public_path__ + "img/clean.ad3a59da.png";